export const Education_Level=[
    {"title":"12th","value":"12th"},
    {"title":"Graduation","value":"Graduation"},
    {"title":"Post Graduation","value":"Post Graduation"},
    {"title":"Engineering","value":"Engineering"},
    {"title":"Medicine","value":"Medicine"},
    {"title":"Law","value":"Law"},
    {"title":"Management","value":"Management"},
    {"title":"Doctor","value":"Doctor"},
    {"title":"Other Diploma","value":"Other Diploma"}
  ]
  